import { createSlice } from "@reduxjs/toolkit";
import {
  getUserList,
  addUserList,
  updateUserList,
  deleteUserList,
  getUserGrid,
  addUserGrid,
  updateUserGrid,
  deleteUserGrid,
  addSupplier,
  getCustomers,
  getSuppliers,
} from "./thunk";

export const initialState = {
  customers: [],
  suppliers: [],
  userList: [],
  userGrid: [],
  errors: {},
  isCreatingSupplier: false,
};

const UsersSlice = createSlice({
  name: "Users",
  initialState,
  reducers: {
    setIsCreatingSupplier: (state: any, action: { payload: boolean }) => {
      state.isCreatingSupplier = action.payload;
    },
  },
  extraReducers: (builder) => {
    // Customers
    builder.addCase(getCustomers.fulfilled, (state: any, action: any) => {
      state.customers = action.payload;
    });
    builder.addCase(getCustomers.rejected, (state: any, action: any) => {
      state.error = action.payload?.error || null;
    });
    // Suppliers
    builder.addCase(getSuppliers.fulfilled, (state: any, action: any) => {
      state.suppliers = action.payload;
    });
    builder.addCase(getSuppliers.rejected, (state: any, action: any) => {
      state.error = action.payload?.error || null;
    });
    builder.addCase(addSupplier.fulfilled, (state: any, action: any) => {
      state.suppliers.unshift(action.payload);
      state.isCreatingSupplier = false;
    });
    builder.addCase(addSupplier.rejected, (state: any, action: any) => {
      state.error = action.payload?.error || null;
      state.isCreatingSupplier = false;
    });

    // List
    builder.addCase(getUserList.fulfilled, (state: any, action: any) => {
      state.customers = action.payload.customers;
      state.suppliers = action.payload.suppliers;
    });
    builder.addCase(getUserList.rejected, (state: any, action: any) => {
      state.error = action.payload?.error || null;
    });
    builder.addCase(addUserList.fulfilled, (state: any, action: any) => {
      state.userList.unshift(action.payload);
    });
    builder.addCase(addUserList.rejected, (state: any, action: any) => {
      state.error = action.payload?.error || null;
    });

    builder.addCase(updateUserList.fulfilled, (state: any, action: any) => {
      state.userList = state.userList.map((list: any) =>
        list.id === action.payload.id ? { ...list, ...action.payload } : list
      );
    });
    builder.addCase(updateUserList.rejected, (state: any, action: any) => {
      state.error = action.payload?.error || null;
    });
    builder.addCase(deleteUserList.fulfilled, (state: any, action: any) => {
      state.userList = state.userList.filter(
        (userList: any) => userList.id.toString() !== action.payload.toString()
      );
    });
    builder.addCase(deleteUserList.rejected, (state: any, action: any) => {
      state.error = action.payload?.error || null;
    });

    // Grid
    builder.addCase(getUserGrid.fulfilled, (state: any, action: any) => {
      state.userGrid = action.payload;
    });
    builder.addCase(getUserGrid.rejected, (state: any, action: any) => {
      state.error = action.payload?.error || null;
    });
    builder.addCase(addUserGrid.fulfilled, (state: any, action: any) => {
      state.userGrid.unshift(action.payload);
    });
    builder.addCase(addUserGrid.rejected, (state: any, action: any) => {
      state.error = action.payload?.error || null;
    });
    builder.addCase(updateUserGrid.fulfilled, (state: any, action: any) => {
      state.userGrid = state.userGrid.map((grid: any) =>
        grid.id === action.payload.id ? { ...grid, ...action.payload } : grid
      );
    });
    builder.addCase(updateUserGrid.rejected, (state: any, action: any) => {
      state.error = action.payload?.error || null;
    });
    builder.addCase(deleteUserGrid.fulfilled, (state: any, action: any) => {
      state.userGrid = state.userGrid.filter(
        (userGrid: any) => userGrid.id.toString() !== action.payload.toString()
      );
    });
    builder.addCase(deleteUserGrid.rejected, (state: any, action: any) => {
      state.error = action.payload?.error || null;
    });
  },
});

export default UsersSlice.reducer;
export const { setIsCreatingSupplier } = UsersSlice.actions;
